<template>
    <div class="table">
        <!-- 头部 -->
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <!-- 表格内容 -->
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <!-- 店铺ID查询 -->
                <el-form-item label="店铺ID:">
                    <el-input v-model="queryParams.shop_id" placeholder="请输入店铺ID" clearable></el-input>
                </el-form-item>

                <!-- 店铺名称查询 -->
                <el-form-item label="店铺名称:">
                    <el-input v-model="queryParams.shop_name" placeholder="请输入店铺名称" clearable></el-input>
                </el-form-item>

                <!-- 店铺别名查询 -->
                <el-form-item label="店铺别名:">
                    <el-input v-model="queryParams.shop_name_alias" placeholder="请输入店铺别名" clearable></el-input>
                </el-form-item>

                <!-- 状态查询 -->
                <el-form-item label="状态:" width="100px">
                    <el-select v-model="queryParams.status" placeholder="请选择状态" clearable @change="changeQuery">
                        <el-option label="停用" :value="0"></el-option>
                        <el-option label="启用" :value="2"></el-option>
                    </el-select>
                </el-form-item>

                <div style="float: right">
                    <el-button type="primary" @click="changeQuery">搜索</el-button>
                </div>
            </el-form>
            <div class="action">
                <el-button type="primary" @click="addShow('inner')">新增门店</el-button>
                <el-button v-if="shopConfig.hotfan_new" type="primary" @click="syncShopNew()">同步门店(食堂)</el-button>
                <el-button v-if="shopConfig.hotfan_guokai" type="primary" @click="syncShopGuokai()">同步门店(国开)</el-button>
            </div>

            <el-table v-loading="loading" :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable">
                <el-table-column prop="id" label="id" width="100" align="center"></el-table-column>
                <el-table-column prop="shop_id" label="店铺ID" align="center" width="200"></el-table-column>
                <el-table-column prop="shop_name" label="店铺名称" align="center" width="200"></el-table-column>
                <el-table-column prop="shop_name_alias" label="店铺别名" align="center" width="150"></el-table-column>
                <el-table-column prop="logo" label="店铺logo" align="center" width="150">
                    <template slot-scope="scope">
                        <el-image
                            v-if="scope.row.logo"
                            :src="scope.row.logo"
                            :preview-src-list="[scope.row.logo]"
                            style="width: 100px; height: 100px"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_link" label="店铺链接" align="center" width="200">
                    <template slot-scope="scope">
                        <el-link :href="scope.row.shop_link" target="_blank" type="primary" v-if="scope.row.shop_link">
                            {{ scope.row.shop_link }}
                        </el-link>
                        <el-button
                            type="text"
                            icon="el-icon-document-copy"
                            @click="copyLink(scope.row.shop_link)"
                            v-if="scope.row.shop_link"
                        >
                            复制
                        </el-button>
                        <span v-if="!scope.row.shop_link">无</span>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_short_link" label="店铺短链接" align="center" width="200">
                    <template slot-scope="scope">
                        <el-link :href="scope.row.shop_short_link" target="_blank" type="primary" v-if="scope.row.shop_short_link">
                            {{ scope.row.shop_short_link }}
                        </el-link>
                        <el-button
                            type="text"
                            icon="el-icon-document-copy"
                            @click="copyLink(scope.row.shop_short_link)"
                            v-if="scope.row.shop_short_link"
                        >
                            复制
                        </el-button>
                        <el-button type="text" icon="el-icon-link" @click="createShortLink(scope.row.id)" v-else> 创建短链接 </el-button>
                        <span v-if="!scope.row.shop_link">无</span>
                    </template>
                </el-table-column>
                <el-table-column prop="spill_price_percent" label="溢价比例" align="center">
                    <template slot-scope="scope"
                        >+ {{ scope.row.spill_price_percent }}%
                        <el-button type="text" style="margin-left: 10px" @click="openEdit(scope.row)">修改记录</el-button></template
                    >
                </el-table-column>
                <el-table-column prop="sync_version" label="同步版本" align="center" width="120"></el-table-column>
                <el-table-column label="默认店铺" prop="is_default" align="center" width="100">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.is_default"
                            :active-value="CommonStateOk"
                            :inactive-value="CommonStateNO"
                            @change="handleDefaultChange(scope.row)"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="status" align="center">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.status === 2">启用</el-tag>
                        <el-tag type="danger" v-else>停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="210" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-paperclip" @click="command(scope.row)">口令 </el-button>
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑 </el-button>
                        <el-button type="text" icon="el-icon-edit" @click="classifyChoiceShow(scope.row)">分类展示 </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 新增 编辑 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="600px" v-if="addVisible" class="dialog_box" :destroy-on-close="true">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules" label-position="right">
                <!-- 店铺名称 -->
                <el-form-item label="店铺名称" prop="shop_name">
                    <el-input v-model="form.shop_name" :disabled="form.shop_src_type !== 'inner'" placeholder="请输入店铺名称"></el-input>
                </el-form-item>

                <!-- 店铺别名 -->
                <el-form-item label="店铺别名" prop="shop_name_alias">
                    <el-input v-model="form.shop_name_alias" placeholder="请输入店铺别名"></el-input>
                </el-form-item>

                <!-- 店铺链接 -->
                <el-form-item label="店铺链接" prop="shop_link">
                    <el-input :disabled="true" v-model="form.shop_link" placeholder="请输入店铺链接"></el-input>
                </el-form-item>

                <!-- Logo -->
                <el-form-item label="店铺Logo">
                    <el-upload
                        class="avatar-uploader"
                        :action="IMAGE_UPLOAD_PRO_URL"
                        :headers="uploadHeaders"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                    >
                        <img v-if="form.logo" :src="form.logo" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div v-if="form.logo" class="avatar-delete-box" @click.stop="handleAvatarRemove">
                            <i class="el-icon-close avatar-delete"></i>
                        </div>
                    </el-upload>
                </el-form-item>

                <!-- 默认店铺 -->
                <el-form-item label="默认店铺">
                    <el-switch v-model="form.is_default" :active-value="CommonStateOk" :inactive-value="CommonStateNO"> </el-switch>
                </el-form-item>

                <!-- 溢价比例 -->
                <el-form-item label="溢价比例(%)" prop="spill_price_percent">
                    <el-input-number
                        v-model="form.spill_price_percent"
                        :min="0"
                        :step="0.1"
                        controls-position="right"
                        style="width: 100%"
                    ></el-input-number>
                </el-form-item>
                <el-form-item label="状态" prop="spill_price_percent">
                    <el-select v-model="form.status" placeholder="请选择状态" clearable>
                        <el-option label="停用" :value="0"></el-option>
                        <el-option label="启用" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增 编辑 -->
        <!-- 将原来的弹窗内容替换为引入的分类树组件 -->
        <el-dialog title="商品分类选择" :visible.sync="classifyChoiceVisible" width="800px" v-if="classifyChoiceVisible" class="dialog_box">
            <ClassifyTree :dataTree="merchantClassifyTree" @checkChange="handlecheckChange" v-if="classifyChoiceVisible"></ClassifyTree>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="
                        classifyChoiceVisible = false;
                        merchantClassifyTree = [];
                    "
                    >取 消</el-button
                >
                <el-button type="primary" @click="saveClassifyChoice">确 定</el-button>
            </span>
        </el-dialog>

        <HotfanEditList :visible.sync="openEditShow" :data="HotfanEditData" />

        <CommandList :dialogVisible.sync="commandDialogVisible" :id.sync="commandId" :shopName.sync="shopName" />
    </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import loadEvents from '@/utils/loading';
import Url from '@/components/Url';
import { request } from '@/common/request';
import { deal } from '@/common/main';
import ClassifyTree from '@/components/goods/ClassifyTree.vue';
import HotfanEditList from './components/HotfanEditList';
import { CommonStateNO, CommonStateOk, IMAGE_UPLOAD_PRO_URL } from '@/common/const';
import CommandList from './components/commandList.vue';
let loads = new loadEvents();
export default {
    name: 'seller',
    components: {
        ClassifyTree,
        Breadcrumb,
        Pagination,
        Url,
        HotfanEditList,
        CommandList
    },
    data() {
        return {
            CommonStateOk: CommonStateOk,
            CommonStateNO: CommonStateNO,
            IMAGE_UPLOAD_PRO_URL: IMAGE_UPLOAD_PRO_URL,
            multiple: false,
            imageUrl: '',
            header: {},
            uploadUrl: process.env.VUE_APP_BASE_API + '/common/upload',
            uploadHeaders: {
                platform: 'admin',
                token: localStorage.getItem('token')
            },
            menuList: ['店铺', '门店管理'],
            queryParams: {
                shop_id: '',
                shop_name: '',
                shop_name_alias: '',
                status: '',
                page: 1,
                pagesize: 10
            },
            shopConfig: {
                hotfan_new: false, // 皓范智慧食堂SAAS
                hotfan_guokai: false
            },
            //验证规则
            rules: {
                shop_name_alias: [
                    {
                        required: false,
                        message: '',
                        trigger: 'blur'
                    }
                ],
                shop_link: [
                    {
                        required: false,
                        message: '',
                        trigger: 'blur'
                    }
                ],
                shop_short_link: [
                    {
                        required: false,
                        message: '',
                        trigger: 'blur'
                    }
                ],
                spill_price_percent: [
                    {
                        required: false,
                        message: '',
                        trigger: 'blur'
                    }
                ]
            },
            form: {
                shop_name: '',
                shop_name_alias: '',
                shop_link: '',
                spill_price_percent: 0,
                id: '',
                status: 2,
                shop_src_type: 'inner',
                is_default: 0,
                logo: ''
            },
            merchantClassifyTree: [],
            selectedClassifyInfo: [],
            current: {},
            loading: false,
            pageInfo: {},
            addVisible: false,
            classifyChoiceVisible: false,
            removeVisible: false,
            confirmVisible: false,
            confirmContent: '',
            title: '加载中',
            mode: 'edit',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },

            openEditShow: false,
            HotfanEditData: {},

            commandDialogVisible: false,
            commandId: null,
            shopName: ''
        };
    },
    created() {
        this.header.token = localStorage.getItem('token');
        this.header.platform = 'admin';
        this.loadData();
        this.loadConfig();
    },
    methods: {
        // 打开修改记录
        openEdit(row) {
            this.HotfanEditData = row;
            this.openEditShow = true;
        },
        // 卡券活动列表
        loadData() {
            this.loading = true;
            request.get('/account/merchant/hotfan/shopList', this.queryParams).then((ret) => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        val.ctime = deal.timestamp(val.ctime, 'unix');
                        val.etime = deal.timestamp(val.etime, 'unix');
                        if (val.usedTime && val.usedTime !== 0) {
                            val.usedTime = deal.timestamp(val.usedTime, 'unix');
                        } else {
                            val.usedTime = '未领取';
                        }

                        return val;
                    });
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 加载配置
        loadConfig() {
            this.loading = true;
            request.get('/account/merchant/shop/config', this.queryParams).then((ret) => {
                if (ret.code === 1) {
                    this.shopConfig = ret.data;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //分页
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.loadData();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.loadData();
        },
        //新增
        add() {
            this.mode = 'add';
            this.title = '新增卡券';
            this.form = {
                state: 2
            };
            this.multiple = true;
            this.addVisible = true;
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        },
        /**
         * 添加
         * @param typeSource
         */
        addShow(typeSource) {
            this.addVisible = true;
            this.form.id = null;
            this.form.shop_src_type = typeSource;
            this.form.shop_name_alias = '';
            this.form.shop_name = '';
        },

        // 口令开关
        command(row) {
            this.commandId = row.shop_id;
            this.shopName = row.shop_name;
            this.commandDialogVisible = true;
        },

        //编辑
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑浩范门店';
            this.multiple = false;
            this.current = row.id;

            const item = this.pageInfo.list[index];

            // 设置表单数据
            this.form = Object.assign({}, item);
            this.addVisible = true;

            // 清除验证
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        },

        //状态
        state(row, state) {
            if (state == 2) {
                this.confirmContent = '确定是否上线?';
            } else {
                this.confirmContent = '确定是否下线?';
            }
            this.form = Object.assign({}, row);
            this.form.state = state;
            this.form.ctime = deal.timestamp(this.form.ctime);
            this.form.etime = deal.timestamp(this.form.etime);
            this.confirmVisible = true;
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        // 处理时间范围
                        if (this.form.timeRange && this.form.timeRange.length === 2) {
                            this.form.ctime = this.form.timeRange[0];
                            this.form.etime = this.form.timeRange[1];
                        }

                        var url = '/account/merchant/hotfan/shop/edit';

                        request.postJson(url, this.form).then((ret) => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') + '成功');
                                this.$refs.form.clearValidate();
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            }
        },
        // 确定下线
        stateData() {
            request.post('/wallet/activity/edit', this.form).then((ret) => {
                if (ret.code == 1) {
                    this.$message.success('操作成功');
                    this.loadData();
                    this.confirmVisible = false;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        classifyChoiceShow(row) {
            this.current = row;
            this.classifyChoiceVisible = true;
            this.loadMerchantClassifyTree(row.shop_id, 'hotfan');
        },
        /**
         * 分类选择
         * @param id integer 分类id
         * @param source string 分类来源
         */
        loadMerchantClassifyTree(id, source) {
            request.get('/goods/merchant/classify/tree', { shopId: id, source: source }).then((ret) => {
                if (ret.code === 1) {
                    this.merchantClassifyTree = ret.data.list;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        // 保存分类选择
        saveClassifyChoice() {
            // console.log('分类id:', this.selectedClassifyInfo.checkedKeys);
            if (!this.selectedClassifyInfo || this.selectedClassifyInfo.checkedKeys.length === 0) {
                this.$message.error('请先勾选分类');
                return;
            }
            // console.log('current', this.current);
            request
                .postJson('/goods/classify/shop/save', {
                    ids: this.selectedClassifyInfo.checkedKeys,
                    shop_src_type: 'hotfan',
                    shop_id: this.current.shop_id
                })
                .then((ret) => {
                    if (ret.code === 1) {
                        this.merchantClassifyTree = ret.data.list;
                    } else {
                        this.$message.error(ret.msg);
                    }
                });
            // 这里可以添加保存分类选择的逻辑
            this.$message.success('分类选择成功');
            this.classifyChoiceVisible = false;
        },
        // 处理分类树勾选变化
        handlecheckChange(checkInfo) {
            console.log(checkInfo, 'checkInfo');
            // 在这里可以获取到完整的 checkInfo 对象
            // console.log('选中的节点:', checkInfo.checked);
            // console.log('选中节点的ID:', checkInfo.checkedKeys);
            // 保存选中的信息
            this.selectedClassifyInfo = checkInfo;

            // 您可以根据需要处理这些数据
            // 例如发送到服务器保存
        },
        syncShopGuokai() {
            request.get('/account/merchant/hotfan/shop/sync').then((res) => {
                if (res.code === 1) {
                    this.$message.success('同步成功');
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        syncShopNew() {
            request.get('/account/merchant/hotfanNew/shop/sync').then((res) => {
                if (res.code === 1) {
                    this.$message.success('同步成功');
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 复制链接功能
        copyLink(link) {
            if (!link) {
                this.$message.warning('链接为空');
                return;
            }

            const textarea = document.createElement('textarea');
            textarea.value = link;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);

            this.$message.success('链接已复制到剪贴板');
        },
        createShortLink(id) {
            request.get('/account/merchant/shop/shortLink/create', { id: id }).then((res) => {
                if (res.code === 1) {
                    this.$message.success('创建成功');
                    this.loadData();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleAvatarSuccess(res, file) {
            if (res.code === 1) {
                this.form.logo = res.data.uri;
                this.$message.success('上传成功');
            } else {
                this.$message.error(res.msg);
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        handleAvatarRemove(file) {
            // console.log(file, 'file');
            this.form.logo = '';
        },
        handleDefaultChange(row) {
            request.postJson('/account/merchant/hotfan/shop/edit', row).then((ret) => {
                if (ret.code == 1) {
                    this.$message.success('设置成功');
                    this.loadData();
                } else {
                    this.$message.error(ret.msg);
                    // 恢复原状态
                    row.is_default = row.is_default === CommonStateOk ? CommonStateNO : CommonStateOk;
                }
            });
        }
    }
};
</script>
<style scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar-delete {
    font-size: 15px;
    color: #fff;
    /* box-shadow: 5px 5px 5px #ccc; */
    transform: rotate(180deg);
    margin-top: 10px;
}
.avatar-delete-box {
    position: absolute;
    right: -17px;
    top: -7px;
    width: 46px;
    height: 26px;
    text-align: center;
    transform: rotate(45deg);
    box-shadow: rgb(204, 204, 204) 0px 1px 1px;
    background: rgb(19, 206, 102);
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>